import React from 'react';
import CountUpCounter from './CountUpCounter';
import { Row, Col } from 'antd';
import { withTranslation } from 'react-i18next';

const Counter = (props) => {
  const { t } = props;

  return (
    <div className="counter-comp-wrapper">
      <Row align="center">
        <Col
          xxl={{ span: 16 }}
          lg={{ span: 18 }}
          md={{ span: 20 }}
          sm={{ span: 24 }}
          span={24}
        >
          <Row align="center">
            <Col
              span={24}
              sm={{ span: 24 }}
              md={{ span: 8 }}
              className="counter-card-wrapper"
            >
              <div className="counter-icon">
                <i className="fa fa-graduation-cap" />
              </div>
              <CountUpCounter countNumber={1594} />
              <div className="description">{t('študentov')}</div>
            </Col>
            <Col
              span={24}
              sm={{ span: 24 }}
              md={{ span: 8 }}
              className="counter-card-wrapper"
            >
              <div className="counter-icon">
                <i className="fa fa-users" />
              </div>
              <CountUpCounter countNumber={101} />
              <div className="description">{t('učiteľov')}</div>
            </Col>
            <Col
              span={24}
              sm={{ span: 24 }}
              md={{ span: 8 }}
              className="counter-card-wrapper"
            >
              <div className="counter-icon">
                <i className="fa fa-handshake" />
              </div>
              <CountUpCounter countNumber={32} />
              <div className="description">{t('partnerov')}</div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default withTranslation()(Counter);
